import React, { Component } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import {
  Body,
  Display,
  Card,
  Caption,
  Keyline,
  ContentAlignment,
  LinkText,
} from 'shared-global-ec-uikit/components/dist/react/esm'
import getConstants from '../../constants'

const { CONTACT_US_URL, BRAND, BASE_URL: homePageUrl } = getConstants()

type OwnProps = {
  title?: string
  componentWillUnmountCallback?: () => void
}

type DefaultProps = Required<Pick<OwnProps, 'title'>>

type Props = OwnProps & WrappedComponentProps

class TemporaryUnavailable extends Component<Props> {
  static defaultProps: Omit<DefaultProps, 'intl'> = {
    title: 'text_error_title',
  }

  componentWillUnmount() {
    const { componentWillUnmountCallback } = this.props

    if (componentWillUnmountCallback) {
      componentWillUnmountCallback()
    }
  }

  render() {
    const {
      intl: { formatMessage },
      title,
    } = this.props

    return (
      <>
        <div className="fr-ec-mb-spacing-06" />
        <div style={{ minHeight: '78vh' }}>
          <Card
            element="div"
            padding="large"
            variant="border"
            className="fr-ec-mb-spacing-06"
            data-test="temporary-unavailable"
          >
            <ContentAlignment
              alignment="stretch"
              direction="column"
              element="div"
            >
              <Display
                variant="display2"
                element="h1"
                className="fr-ec-mb-spacing-06"
              >
                {formatMessage({ id: title || '' })}
              </Display>

              <Keyline className="fr-ec-mb-spacing-05" />

              <Body element="p" className="fr-ec-mb-spacing-02">
                {formatMessage({ id: 'text_503_error_description-1' })}
              </Body>
              <Body element="p" className="fr-ec-mb-spacing-02">
                {formatMessage({ id: 'text_503_error_description-2' })}
              </Body>
              <Body element="p" className="fr-ec-mb-spacing-05">
                {formatMessage({ id: 'text_503_error_instruction' })}
              </Body>
              <Body element="div" className="fr-ec-mb-spacing-05">
                <LinkText element="a" href={homePageUrl}>
                  <Caption
                    variant="emphasized"
                    element="p"
                    className="fr-ec-mb-spacing-02"
                  >
                    {formatMessage({
                      id: `text_go_to_top_${BRAND}`,
                    })}
                  </Caption>
                </LinkText>{' '}
                <LinkText element="a" href={CONTACT_US_URL}>
                  <Caption variant="emphasized" element="p">
                    {formatMessage({ id: 'text_contactus' })}
                  </Caption>
                </LinkText>
              </Body>
            </ContentAlignment>
          </Card>
        </div>
      </>
    )
  }
}

export default injectIntl(TemporaryUnavailable)
